/* eslint-disable no-unused-vars */
import axios from "../../axios";
import {
  DEAL_STATUS_NEW,
  DEAL_STATUS_APPROVED,
  DEAL_STATUS_SIGNED,
} from "@/utils/constants/deal";

/**
 * Caches deal-related enums fetched from /api/get-data/deal-options.
 * Replaces hard-coded magic numbers across
 * DealDetails, DealTable, DealStatusModal.
 *
 * Usage:
 *   await this.$store.dispatch("dealOptions/load")
 *   const types = this.$store.state.dealOptions.dealTypes
 *   const map = this.$store.getters["dealOptions/dealTypeMap"]
 */
const state = {
  loaded: false,
  loading: false,
  dealTypes: [],
  statuses: [],
  specialStatusIds: {
    new: DEAL_STATUS_NEW,
    approved: DEAL_STATUS_APPROVED,
    signed: DEAL_STATUS_SIGNED,
  },
  convertingSourceRenewId: 5,
  constants: {
    week_in_month: 4,
    unit_price_default: 150000,
  },
};

const mutations = {
  SET_LOADING(state, val) {
    state.loading = val;
  },
  SET_OPTIONS(state, data) {
    state.dealTypes = data.deal_types || [];
    state.statuses = data.statuses || [];
    state.specialStatusIds = data.special_status_ids || state.specialStatusIds;
    state.convertingSourceRenewId =
      data.converting_source_renew_id || state.convertingSourceRenewId;
    state.constants = data.constants || state.constants;
    state.loaded = true;
  },
};

const actions = {
  async load({ commit, state }, force = false) {
    if (state.loaded && !force) return;
    if (state.loading) return;
    commit("SET_LOADING", true);
    try {
      const res = await axios.get("/get-data/deal-options");
      commit("SET_OPTIONS", res.data);
    } catch {
      // Store handles graceful fallback — components check state.loaded
    } finally {
      commit("SET_LOADING", false);
    }
  },
};

const getters = {
  dealTypeMap: (state) =>
    state.dealTypes.reduce((acc, t) => {
      acc[t.id] = t;
      return acc;
    }, {}),
  dealTypeLabel: (state, getters) => (id) =>
    getters.dealTypeMap[id]?.label || `Type #${id}`,
  statusMap: (state) =>
    state.statuses.reduce((acc, s) => {
      acc[s.id] = s;
      return acc;
    }, {}),
  selectableStatuses: (state) => {
    return state.statuses.filter((s) => s.selectable !== false);
  },
  isSignedStatus: (state) => (id) =>
    Number(id) === Number(state.specialStatusIds.signed),
  isRenewSource: (state) => (id) =>
    Number(id) === Number(state.convertingSourceRenewId),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
